import React from "react"
import { useNavigate } from "react-router-dom"
import ProtectedLayout from "layouts/Protected"
import { useTranslation } from "react-i18next"

const NotAuthorized = () => {
	const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <ProtectedLayout className="px-5 p-12">
            <div className="l-container-md">
                <div className="text-center">
                    <h1 className="c-h2 mt-12 font-bold text-primary text-center mb-12">{t("notAuthorized.title")}</h1>
                    <button onClick={() => navigate(-1)} className="c-btn c-btn--primary mx-auto px-12">
                        {t("notAuthorized.goback")}
                    </button>
                </div>
            </div>
        </ProtectedLayout>

    )

}


export default NotAuthorized